import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IFinanceVisibility {
  /**
   * 客户资产数据可见状态
   *
   * @type {boolean}
   * @memberof IFinanceVisibility
   * @example {'financeVisibility': true} <br>
   * true 显示明文
   * false 显示密文
   */
  financeVisibility: boolean
}

interface IFinanceVisibilityResponse {
  success?: (result: IFinanceVisibility) => void
  fail?: (result: IFinanceVisibility) => void
  complete?: (result: IFinanceVisibility) => void
}

/**
 * 获取客户资产数据可见状态
 *
 * @param {IBridgeOptions<IClientResponse>} { success, fail, complete }
 */
function getFinanceVisibilitySync({
  success,
  fail,
  complete
}: IBridgeOptions<IFinanceVisibilityResponse>) {
  const params = formatParams({
    funType: 'appInfo',
    funName: 'getFinanceVisibility'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getFinanceVisibilitySync error: ', error)
  }
}

/**
 * 获取客户资产数据可见状态<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<IFinanceVisibility>}
 */
function getFinanceVisibility(): Promise<IFinanceVisibility> {
  const params = formatParams({
    funType: 'appInfo',
    funName: 'getFinanceVisibility'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

/**
 * 设置客户资产数据可见状态
 *
 * @param {IBridgeOptions<IFinanceVisibilityResponse>} { success, fail, complete }
 */
function setFinanceVisibilitySync({
  financeVisibility,
  success,
  fail,
  complete
}: IBridgeOptions<IFinanceVisibilityResponse>) {
  const params = formatParams({
    funType: 'appInfo',
    funName: 'setFinanceVisibility',
    financeVisibility
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('setFinanceVisibilitySync error: ', error)
  }
}

/**
 * 设置客户资产数据可见状态<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @param {IFinanceVisibility} financeVisibility
 * @returns
 */
function setFinanceVisibility(financeVisibility: IFinanceVisibility) {
  const params = formatParams({
    funType: 'appInfo',
    funName: 'setFinanceVisibility',
    financeVisibility
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export {
  getFinanceVisibility,
  getFinanceVisibilitySync,
  setFinanceVisibility,
  setFinanceVisibilitySync
}
